"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearPlayerAction = void 0;
const logic_types_1 = require("../logic-types");
class ClearPlayerAction {
    constructor(board, playerPileId) {
        this.board = board;
        this.playerPileId = playerPileId;
    }
    execute() {
        const originPile = this.board.getPileByPileId(this.playerPileId);
        if (!originPile.hasCards) {
            throw new Error("No player cards to clear");
        }
        const targetPile = this.board.getPileByPileId(logic_types_1.PileId.Waste);
        this.cards = originPile.allCards.map((card) => card.clone());
        this.cards.forEach((card) => {
            targetPile.addCard(card);
        });
        originPile.removeAllCards();
    }
    resolve() {
        // Nothing
    }
    static isAction(action) {
        return action instanceof ClearPlayerAction;
    }
}
exports.ClearPlayerAction = ClearPlayerAction;
